import { render, staticRenderFns } from "./OpenAlexStats.vue?vue&type=template&id=071d82e0&scoped=true"
import script from "./OpenAlexStats.vue?vue&type=script&lang=js"
export * from "./OpenAlexStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d82e0",
  null
  
)

export default component.exports